import './bootstrap';
import '../css/app.css';
import mitt from 'mitt';
import { createApp, h } from 'vue';
import { createInertiaApp, usePage } from '@inertiajs/vue3';
import { createPinia } from 'pinia';
import menu_layout from './Layouts/menu_layout.vue';
import OneSignalVuePlugin, { useOneSignal } from '@onesignal/onesignal-vue3';
import { AuthUser } from './Interfaces/AuthUser';
import axios from 'axios';
import Layout from './utils/layout';
import Bugsnag from '@bugsnag/js';
import BugsnagPluginVue from '@bugsnag/plugin-vue';
import startSentry from './config/start_sentry';

const emitter = mitt();
const pinia = createPinia();
const layout = new Layout();

//Váriaves que estão declaradas no define no vite.config.js
const envs = {
	_APP_ENV_: APP_ENV,
	_APP_VERSION_: APP_VERSION,
	_SENTRY_VUE_DSN_: SENTRY_VUE_DSN,
};

const app_in_production = envs._APP_ENV_ !== 'local';

function startBugsnag(vueApp) {
	Bugsnag.start({
		apiKey: import.meta.env.VITE_BUGSNAG_API_KEY,
		plugins: [new BugsnagPluginVue()],
		appVersion: envs._APP_ENV_ + '@' + envs._APP_VERSION_,
	});
	const bugsnagVue = Bugsnag.getPlugin('vue');
	vueApp.use(bugsnagVue);
}

function startOneSignal(vueApp) {
	vueApp.use(OneSignalVuePlugin, {
		appId: import.meta.env.VITE_USER_ONE_SIGNAL_APP_ID,
	});
}

createInertiaApp({
	resolve: (name) => {
		const pages = import.meta.glob('./Pages/**/*.vue', {
			eager: true,
		}) as Record<string, unknown>;
		let page = pages[`./Pages/${name}.vue`] as any;
		if (!page.default.layout && layout.pageShouldHaveDefaultLayout(name)) {
			page.default.layout = menu_layout;
		}
		return page;
	},
	setup({ el, App, props, plugin }) {
		const vueApp = createApp({ render: () => h(App, props) });

		if (app_in_production) {
			startSentry(
				vueApp,
				envs._SENTRY_VUE_DSN_,
				envs._APP_VERSION_,
				envs._APP_ENV_
			);
			startBugsnag(vueApp);
			startOneSignal(vueApp);
		}

		vueApp.provide('emitter', emitter);
		vueApp.use(pinia);
		vueApp.use(plugin).mount(el);

		if (!window.location.pathname.includes('/prova/')) {
			runOneSignal();
		}

		return vueApp;
	},
});

async function runOneSignal() {
	const auth_user = usePage().props?.auth_user as AuthUser;

	if (auth_user.user_logged_in) {
		const OneSignal = useOneSignal();

		const enrollment_id =
			auth_user.enrollment !== null
				? auth_user.enrollment.id.toString()
				: null;

		if (enrollment_id) {
			OneSignal.on('subscriptionChange', async (isSubscribed) => {
				if (isSubscribed) {
					const player_id = await OneSignal.getUserId();
					const device = navigator.userAgent;

					axios
						.post('/save-push-notification-data', {
							player_id: player_id,
							device: device,
							enrollment_id: enrollment_id,
						})
						.then(async (response) => {
							console.log(response);
							await OneSignal.setExternalUserId(enrollment_id);
						});
				}
			});
		}
	}
}
